import React from "react";
import { useNavigate } from "react-router-dom";

function DeliveryHome() {
  const navigate = useNavigate();
  return (
    <div className="goody-container">
      <div className="heading-goody">
        <h1>DriveOme</h1>
        <p className="text-center">
          Reliable and fast delivery services at your doorstep
        </p>
      </div>

      <div className="goody-cardcontianer">
        {/* In-City Delivery */}
        <div onClick={() => navigate("/local")} className="goody-card">
          <div className="img-container">
            <img
              src="\asessts\Images\cr=w_730,h_549.webp"
              className="img-fluid"
              alt="In-City Delivery"
              width={"270px"}
              height={"240px"}
            />
          </div>
          <div className="local">
            <h2 style={{ fontWeight: "400", color: "#1B1B1B" }}>
              Parcel Delivery
            </h2>
          </div>
          <div className="business">
            <p>
              Fast and reliable delivery within your city. Ideal for personal
              parcels, documents, and small packages.
            </p>
          </div>
        </div>

        {/* Packers & Movers */}
        <div
          className="goody-card"
          onClick={() => navigate("/packersandmovers")}
        >
          <div className="img-container">
            <img
              src="\asessts\Images\rental.avif"
              alt="Packers & Movers"
              style={{ maxWidth: "100%" }}
              height={"200px"}
            />
          </div>
          <div className="local">
            <h2 style={{ fontWeight: "400", color: "#1B1B1B" }}>
              Packers & Movers
            </h2>
          </div>
          <div className="business">
            <p>
              Professional relocation services for homes and offices. Secure
              packing, safe transport, and on-time delivery.
            </p>
          </div>
        </div>

        {/* Outstation / Long-Haul Delivery */}
        <div className="goody-card" onClick={() => navigate("/outstation")}>
          <div className="img-container">
            <img
              src="\asessts\Images\Outstation.webp"
              className="img-fluid"
              alt="Outstation Delivery"
              width={"270px"}
            />
          </div>
          <div className="local">
            <h2 style={{ fontWeight: "400", color: "#1B1B1B" }}>
              Outstation Delivery
            </h2>
          </div>
          <div className="business">
            <p>
              Nationwide long-haul delivery services. Transport large goods,
              industrial items, or bulk shipments safely across India.
            </p>
          </div>
        </div>
      </div>
    </div>
  );
}

export default DeliveryHome;
